import { useState } from "react";
import { api, resolveUrl } from "../../../../config/apis";
import AdminApi from "../../../../config/apis/admin";
import { useNavigate } from "react-router-dom";
import { useStudentReportContext } from "../../../../context/StudentReportContext";

const useGenrateReport = ({ columnsWithIds }) => {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [responseData, setResponseData] = useState(null);

  const nevigate = useNavigate();

  const { updateStudentReports } = useStudentReportContext();

  const handleSubmit = async ({ courseState, courseFilter }) => {
    setIsLoading(true);

    // Validation for date_range filters
    for (const item of columnsWithIds) {
      if (item.type === "date_range") {
        const key = item.label.replace(/\s+/g, "_").toLowerCase();
        if (!(key in courseState) || !courseState[key].min || !courseState[key].max) {
          setIsError(true);
          setErrorMsg(["Please select both start and end dates for the date range filter."]);
          setIsLoading(false);
          return;
        }
      }
    }

    const selectedItem = {};
    if (columnsWithIds) {
      columnsWithIds.forEach((item) => {
        const key = item.label.replace(/\s+/g, "_").toLowerCase();
        const type = item.type;
        if (!(key in courseState)) {
          switch (type) {
            case "select":
              if (
                // If 'select' options include 'yes' or 'no' (case-insensitive), default to 'all'
                item.options &&
                item.options.some(
                  (opt) =>
                    typeof opt === "string" &&
                    (opt.toLowerCase() === "yes" || opt.toLowerCase() === "no")
                )
              ) {
                selectedItem[key] = "all";
              } else {
                selectedItem[key] = "yes";
              }
              break;
            case "multi_select":
              selectedItem[key] = ["yes"];
              break;
            case "hq_multiselect":
              selectedItem[key] = ["yes"];
              break;
            case "org_multiselect":
              selectedItem[key] = ["yes"];
              break;
            case "range":
              selectedItem[key] = {
                min: 0,
                max: 100,
              };
              break;
            default:
              selectedItem[key] = "yes";
              break;
          }
          // if (key === "organization") {
          //   selectedItem[key] = [0];
          // }
        }
      });
    }

    try {
      const response = await api.post(
        resolveUrl(AdminApi.GENRATE_STUDENT_REPORTS),
        { ...courseFilter, ...courseState, ...selectedItem }
      );
      if (response.data) {
        setIsError(false);
        setSuccessMsg(response.data.message);
        setResponseData(response.data);
        updateStudentReports(response.data.data ?? []);
        nevigate(`/admin/students-reports`);
        setIsLoading(false);
      }
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      let message = "";
      if (error.response) {
        if (error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
      }

      setErrorMsg([message]);
      console.error("Error occurred while logging in:", error);
    }
  };

  const clearError = () => {
    setIsError(false);
    setErrorMsg([]);
  };

  return {
    handleSubmit,
    isError,
    errorMsg,
    successMsg,
    responseData,
    isLoading,
    clearError,
  };
};

export default useGenrateReport;
